import React from 'react';
import { MsalProvider, useMsal } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
import { LoginMicrosoft, LoginMicrosoftBtn } from './styled';

function MicrosoftButtonLogin({ onMicrosoftLogin, changeInstance, changeAccount }) {
	const { inProgress } = useMsal();

	const handleMicrosoftLogin = async() => {
		try{
			const response = await msalInstance.loginPopup()
			// Assuming 'response' contains the necessary tokens
			// Make a call to Microsoft Graph API to get user's email
			await changeInstance(msalInstance)
			await changeAccount(response)
			const emailLogin = response.account.username;

			if (emailLogin) {
				onMicrosoftLogin(response, emailLogin);
				// window.close(); // Fechar a janela pop-up após o login
			}
		} catch (error) {
			if (error.errorMessage === "user_cancelled: User cancelled the flow") {
				// Usuário cancelou o login, exibir uma mensagem para informá-lo
				console.error("O login foi cancelado pelo usuário.");
			} else {
				// Outro erro ocorreu, tratar conforme necessário
				console.error("Erro durante o login:", error);
			}
		}
	};

	// Configuração do MSAL
	const msalConfig = {
		auth: {
			clientId: 'c4cc7c3a-0323-4032-a63c-f114ca57f892',
			authority: 'https://login.microsoftonline.com/dff5d80f-6e71-4199-9a3f-bf5dc8891d18',
			redirectUri: 'https://app.npegroup.com.br',
		},
	};

	const msalInstance = new PublicClientApplication(msalConfig);

	return (
		<MsalProvider instance={msalInstance}>
			<LoginMicrosoft>
				<LoginMicrosoftBtn onClick={handleMicrosoftLogin}>
					<img
						src={'./images/microsoft.png'}
						alt="Microsoft Logo"
						style={{ marginRight: '10px', width: '20px', height: '20px' }}
					/>
					Acesse com Microsoft
				</LoginMicrosoftBtn>
			</LoginMicrosoft>
		</MsalProvider>
	);
}

export default MicrosoftButtonLogin;
